import React from 'react';
import ListStyleOne from '../../components/list-style/one';
import HomeContentSection from '../Home/HomeContentSection';
import Clients from '../Industries/Industry/Clients/';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import {colors} from '../../style/constants';

const useStyles = makeStyles(() => ({
  catchphrase: {
    background: colors.LIGHT_GREY,
  },
  carousel: {
    paddingTop: 0,
  },
}));

const TouchScreen = (props) => {
  const classes = useStyles();
  return (
    <>
      <section id='touch-projects-types'>
        <ListStyleOne lang={props.lang} align='left' items={props.types.edges[0]} touchScreen/>
        <ListStyleOne lang={props.lang} align='right' items={props.types.edges[1]} touchScreen/>
        <ListStyleOne lang={props.lang} align='left' items={props.types.edges[2]} touchScreen/>
        <ListStyleOne lang={props.lang} align='right' items={props.types.edges[3]} touchScreen/>
      </section>
      <section className={classes.catchphrase + " clipped"}>
      <Container className={classes.container}>
        <h2>{props.lang === 'en-CA' ? 'Innovation is at your doorstep and we have everything you need to make your project happen.' :'L’innovation est à vos portes et nous avons tout ce qu’il faut pour réaliser le projet avec vous.'}</h2>
      </Container>
    </section>
       <section className={classes.carousel}>
        <Container>
          <Clients lang={props.lang} items={props.carouselDatas}/>
        </Container>
      </section>
      <HomeContentSection lang={props.lang}/>
    </>
  );
}
  
export default TouchScreen;